<template>
    <div class="content" style="padding:0;">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">当事人信息</span>
                <el-button type="warning" size="small" @click="getBack" style="margin-right: 20px;margin-left:0;">返回</el-button>
                <el-button type="primary" size="small" @click="zhedie">{{isZhedie ? '展开' : '折叠'}}</el-button>
            </div>
            <div class="box-cont" :style="{'display':isZhedie ? 'none' : 'block'}">
                <el-form :model="form1" ref="form1" label-width="100px">
                    <template v-if="form1.jingyingzhe=='个人'||form1.jingyingzhe=='公民'">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="法人类别:" prop="jingyingzhe" >
                                    <el-select disabled v-model="form1.jingyingzhe" clearable placeholder="请选择" size="small">
                                        <el-option 
                                            v-for="dict in jingyingzheOptions"
                                            :key="dict.id"
                                            :label="dict.jingyingzhe"
                                            :value="dict.jingyingzhe"
                                            ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item disabled label="个人:" prop="jingyingzhexm">
                                    <el-input
                                    v-model="form1.jingyingzhexm"
                                    placeholder="请输入个人"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="性别:" prop="frxb">
                                    <!-- :disabled="dwForm.frxb?true:false" -->
                                    <el-select disabled v-model="form1.frxb" placeholder="" size="small">
                                        <el-option 
                                            v-for="dict in xbOptions"
                                            :key="dict.id"
                                            :label="dict.label"
                                            :value="dict.label"
                                            ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="民族:" prop="nation">
                                    <el-select disabled v-model="form1.nation" placeholder="请选择民族" size="small">
                                        <el-option
                                            v-for="dict in mzOptions"
                                            :key="dict.id"
                                            :label="dict.nation"
                                            :value="dict.xh"
                                            ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="住址:" prop="zhuzhi">
                                    <!-- :disabled="dwForm.dwdz?true:false" -->
                                    <el-input disabled
                                    v-model="form1.zhuzhi"
                                    placeholder="请输入住址"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="联系电话:" prop="sj1">
                                    <el-input  disabled
                                    v-model="form1.sj1"
                                    placeholder="请输入联系电话"
                                    clearable
                                    size="small"
                                    />
                                </el-form-item>  
                            </el-col> 
                            <el-col :span="8">
                                <el-form-item label="身份证号:" prop="sfzh">
                                    <!-- :disabled="dwForm.sfzh?true:false" -->
                                    <el-input disabled
                                    v-model="form1.sfzh"
                                    placeholder="请输入身份证号"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="地址:" prop="dwdz">
                                    <!-- :disabled="dwForm.dwdz?true:false" -->
                                    <el-input disabled
                                    v-model="form1.dwdz"
                                    placeholder="请输入地址"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-else>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="当事人:" prop="dwmc">
                                    <el-input disabled
                                    v-model="form1.dwmc"
                                    placeholder="请输入当事人"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="地址:" prop="dwdz">
                                    <el-input disabled
                                    v-model="form1.dwdz"
                                    placeholder="请输入地址"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="xkzText" prop="xkzh" :label-width="dwForm.zylbId == '06'?'160px':'140px'">
                                    <el-input disabled
                                    v-model="form1.xkzh"
                                    placeholder="请输入卫生许可证号"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="统一社会信用代码:" prop="zzdm" label-width="140px">
                                    <el-input  disabled
                                    v-model="form1.zzdm"
                                    placeholder="请输入统一社会信用代码"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item disabled :label="form1.jingyingzhe?form1.jingyingzhe+':':'负责人:'" prop="fr"  label-width="120px">
                                    <!-- :disabled="dwForm.fzr?true:false" -->
                                    <el-input  disabled
                                    v-model="form1.fr"
                                    placeholder="请输入"
                                    clearable
                                    size="small"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-form-item label="性别:" prop="frxb" label-width="55px">
                                    <!-- :disabled="dwForm.frxb?true:false" -->
                                    <el-select  disabled v-model="form1.frxb" placeholder="" size="small">
                                        <el-option
                                            v-for="dict in xbOptions"
                                            :key="dict.id"
                                            :label="dict.label"
                                            :value="dict.label"
                                            ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="民族:" prop="nation" label-width="55px">
                                        <!-- :disabled="dwForm.nation?true:false" -->
                                    <el-select disabled v-model="form1.nation" placeholder="请选择民族" size="small">
                                        <el-option
                                            v-for="dict in mzOptions"
                                            :key="dict.id"
                                            :label="dict.nation"
                                            :value="dict.nation"
                                            ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="职务:" prop="frzw" label-width="55px">
                                    <el-input disabled
                                        v-model="form1.frzw"
                                        placeholder="请输入单位名称"
                                        clearable
                                        size="small"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="9">
                                <el-form-item label="身份证号:" prop="sfzh">
                                    <!-- :disabled="dwForm.sfzh?true:false" -->
                                    <el-input disabled
                                    v-model="form1.sfzh"
                                    placeholder="请输入身份证号"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="联系电话:" prop="sj1">
                                <!-- :disabled="dwForm.sj1?true:false" -->
                                    <el-input  disabled
                                    v-model="form1.sj1"
                                    placeholder="请输入联系电话"
                                    clearable
                                    size="small"
                                    />
                                </el-form-item>  
                            </el-col> 
                        </el-row>
                    </template>                    
                </el-form>
            </div>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="18">
                <el-form :model="form2" ref="queryForm2" label-width="0px">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span class="text">现场检查文书</span>
                                   
                                    <el-upload
                                            
                                            style="float:right;"
                                            action="#"
                                            :http-request="handleXcjcUpload"
                                            
                                            :before-upload="beforeUpload"
                                            :on-change="(file, fileList) => handleChange(file, fileList, 'xcjczj')"
                                            :show-file-list="false" :auto-upload="false"
                                            multiple>

                                            <el-button size="small" type="warning" icon="el-icon-upload2">上传</el-button>
                                        </el-upload>
                                </div>
                                <div class="box-cont" style="min-height: 60px;max-height: 220px; overflow-y:auto;margin-bottom: 20px;">
                                    <el-table v-loading="tlIndex == 12 ? 'loadingTl':''" :data="xcjczjTags">
                                        <el-table-column  align="center" type="index" label="序号" width="60" />
                                        <el-table-column label="文书名称" align="center" prop="fileName" width="180">
                                            <template slot-scope="scope">
                                                <a :href="scope.row.fileUrl" target="_blank" style="color: #409eff;">
                                                    {{ removeFileExtension(scope.row.fileName) }}
                                                </a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="内容">
                                            <template slot-scope="scope">
                                                <div style="display: flex; align-items: flex-start; gap: 8px; width: 100%;">
                                            <!-- 只读模式 -->
                                            <div v-if="!scope.row.isEditing" style="display:flex; align-items:center; flex:1; min-width:0;">
                         
                                            <div style="flex: 1; min-width:0; display:flex; align-items:center; overflow:hidden;">
                                                <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                {{ scope.row.remarks }}
                                                </span>
                                            </div>
                                            </div>
                                                <el-input
                                                    v-else
                                                    v-model="scope.row.remarks"
                                                    type="textarea"
                                                    :autosize="{ minRows: 3, maxRows: 4 }"
                                                    style="flex:1;"
                                                />
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="" align="center" class-name="small-padding" width="50">
                                            <template slot-scope="scope">
                                                <div style="display:flex; justify-content:center; align-items:center; height:100%; gap:4px;">
                                                <!-- 复制按钮 -->
                                                <a class="fuzhi" @click="getText(scope.row.remarks)" style="display:flex; align-items:center;">
                                                    <i></i>
                                                </a>
                                                <!-- 放大按钮 -->
                                                <a class="fangda" @click="getBig(scope.row.remarks)" style="display:flex; align-items:center;">
                                                    <img src="@/assets/images/big.png" style="width:16px; height:16px; display:block;">
                                                </a>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="160" >
                                            <template slot-scope="scope">
                                                <el-button
                                                    size="small"
                                                    type="text"
                                                    @click="deleUpload(scope.row.id)"
                                                >删除</el-button>
                                          <el-button
                                        size="small"
                                        type="text"
                                        @click="scope.row.isEditing = !scope.row.isEditing"
                                        >
                                        {{ scope.row.isEditing ? '取消编辑' : '编辑' }}
                                        </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="box-cont"  style="min-height: 20px; max-height: 190px; overflow-y:auto;">
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="主案由:" prop="reason2" label-width="80px">
                                                <el-input disabled
                                                v-model="form2.reason2"
                                                placeholder="请输入"
                                                clearable
                                                size="small"  style="width:calc(100% - 200px);margin-right:10px;"
                                                />
                                                <el-button type="primary" size="small" @click="getAnyou('主案由',1)">选择模板</el-button>
                                                <el-button type="primary" size="small" @click="addAy()">增加从案由</el-button>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24" v-show="(form2.reason22 && form2.reason22 != '无') || isCay">
                                            <el-form-item label="从案由:" prop="reason22" label-width="80px">
                                                <el-input disabled
                                                v-model="form2.reason22"
                                                placeholder="请输入"
                                                clearable
                                                size="small"  style="width:calc(100% - 266px);margin-right:10px;"
                                                />
                                                <el-button type="primary" size="small" @click="getAnyou('从案由',2)">选择模板</el-button>
                                                <el-button type="primary" size="small" @click="addAnyou()">增加从案由</el-button>
                                                <el-button type="danger" size="small" @click="delectReason22()">删除</el-button>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24" v-show="isAy > 1">
                                            <el-form-item v-for="(item,index) in form2.domains" :key="index" :label="'从案由'+item.key+':'"  label-width="80px">
                                                <el-input disabled
                                                v-model="item.value"
                                                placeholder="请输入"
                                                clearable
                                                size="small"  style="width:calc(100% - 200px);margin-right:10px;"
                                                />
                                                <el-button type="primary" size="small" @click="getAnyou('从案由',2,index)">选择模板</el-button>
                                                <el-button type="danger" size="small" @click="delectAnyou(index,item.id)">删除</el-button>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24"  v-show="(form2.reason22 && form2.reason22 != '无') || isCay">
                                            <el-form-item label="合并案由:" prop="Hreason22" label-width="80px">
                                                <el-input disabled
                                                v-model="form2.Hreason22"
                                                placeholder="请输入"
                                                clearable
                                                size="small" style="width:calc(100% - 200px);margin-right:10px;"
                                                />
                                                <el-button type="primary" size="small" @click="getHbAnyou()">合并案由</el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span class="text">主体资格证据</span>  
                                    <el-upload multiple
                                            style="float:right;"
                                            action="#"
                                            :http-request="handleZtzgUpload"  
                                            :before-upload="beforeUpload"
                                            :on-change="(file, fileList) => handleChange(file, fileList, 'ztzgzj')"
                                            :show-file-list="false" :auto-upload="false">
                                            <el-button size="small" type="warning" icon="el-icon-upload2">上传</el-button>
                                        </el-upload>
                                </div>
                                <div v-loading="tlIndex == 10 ? 'loadingTl':''" element-loading-text="上传中，请等待3~5秒..." style="height: 144px;">
                                    <el-form-item label="">
                                        <div class="tag-container" style="width:100%;border: 1px solid #DCDFE6; 
                                          height: 142px;
                                          border-radius: 4px;overflow: auto;">
                                            <el-tag
                                                v-for="(item, index) in ztzgzjTags"
                                                :key="index"
                                                closable @click="openFile(item.fileUrl)"
                                                @close="deleUpload(item.id)"
                                                style="margin: 5px;"
                                            >
                                                {{index+1}}、{{ removeFileExtension(item.fileName) }}
                                            </el-tag>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span class="text">违法事实证据</span>  
                                    <el-upload
                                            style="float:right;"
                                            action="#"
                                            multiple
                                            :http-request="handleWfssUpload"
                                            :before-upload="beforeUpload"
                                            :on-change="(file, fileList) => handleChange(file, fileList, 'wfsszj')"
                                            :show-file-list="false"
                                            :auto-upload="false">
                                            <el-button size="small" type="warning" icon="el-icon-upload2">上传</el-button>
                                        </el-upload>    
                                </div>
                                <div v-loading="tlIndex == 11 ? 'loadingTl':''" element-loading-text="上传中，请等待3~5秒..." style="height: 144px;">
                                    <el-form-item label="">
                                        <div class="tag-container" style="width:100%;    height: 142px;border: 1px solid #DCDFE6; border-radius: 4px;overflow: auto;">
                                            <el-tag
                                                v-for="(item, index) in wfsszjTags"
                                                :key="index"
                                                closable @click="openFile(item.fileUrl)"
                                                @close="deleUpload(item.id)"
                                                style="margin: 5px;"
                                            >
                                                {{index+1}}、{{ removeFileExtension(item.fileName) }}
                                            </el-tag>
                                        </div>
                                        
                                    </el-form-item>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="24">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span class="text">案件主要元素</span>
                                    <a class="tlAnniu" @click="handleGetTuili('ajdcbg',6)" style="float: right; margin: 8px 20px 0 0;  line-height: 28px;  padding-left: 30px; width: 40px;  cursor: pointer;">推理</a>
                                    <el-button type="primary" size="small" @click="handleSubmit" style="margin-right: 20px;margin-left:0;">保存</el-button>
                                    <el-button v-if="isZt != 1" type="warning" size="small" @click="save(0)">暂存</el-button>
                                </div>
                                <div class="tl-content" v-loading="tlIndex == 6 ? 'loadingTl':''" element-loading-text="推理中，请等待3~5秒..." style="height:500px;overflow-y: auto;">
                                    <el-form-item label="">
                                        <h5>经后续调查证实</h5>
                                        <el-input type="textarea" v-model="form2.ajdcbg.jhxdczs" :autosize="{minRows:4, maxRows: 8}" @input="setLiucheng(6)"></el-input>
                                        <a class="fuzhi" @click="getText(form2.ajdcbg.jhxdczs)"><i></i></a>
                                        <a class="fangda" @click="getBig(form2.ajdcbg.jhxdczs)"><img src="@/assets/images/big.png"></a>
                                    </el-form-item>                         
                                    <el-tabs type="border-card" style="margin-top:10px;padding:0;border:none;border-top:1px solid #DCDFE6;" v-model="wfqx_val" :before-leave="change_wfqx" closable @tab-remove="removeTab">
                                        <el-tab-pane v-for="(item, index) in form2.ajdcbg.data" :key="index" :name="String(index)" :label="'违法事实'+(index + 1)">
                                        <el-row>
                                            <el-col  :span="24">
                                            <el-form-item label="" class="textarea_item">
                                                <h5>案由</h5>
                                                <el-input v-model="item.ay" @input="renew($event)" size="small"></el-input>
                                                <a class="fuzhi" @click="getText(item.ay)"><i></i></a>
                                                <a class="fangda" @click="getBig(item.ay)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                            <el-col  :span="24">
                                            <el-form-item label="" class="textarea_item">
                                            <h5>违法行为</h5>
                                                <el-input v-model="item.wfxw" type="textarea" @input="renew($event)"
                                                :autosize="{minRows: 2, maxRows: 4}" ></el-input>
                                                <a class="fuzhi" @click="getText(item.wfxw)"><i></i></a>
                                                <a class="fangda" @click="getBig(item.wfxw)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                            <el-col  :span="24">
                                            
                                            <el-form-item label="" class="textarea_item">
                                            <h5>违反法律</h5>
                                                <el-input v-model="item.wffl" @input="renew($event)" type="textarea" :autosize="{minRows: 2, maxRows: 4}"></el-input>
                                                <a class="fuzhi" @click="getText(item.wffl)"><i></i></a>
                                                <a class="fangda" @click="getBig(item.wffl)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                            <el-col  :span="24">
                                            <h5></h5>
                                            <el-form-item label="" class="textarea_item">
                                            <h5>处罚依据</h5>
                                                <el-input v-model="item.cfyj" @input="renew($event)" type="textarea" :autosize="{minRows: 2, maxRows: 4}"></el-input>
                                                <a class="fuzhi" @click="getText(item.cfyj)"><i></i></a>
                                                <a class="fangda" @click="getBig(item.cfyj)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                            <el-col  :span="24">
                                            <el-form-item label="" class="textarea_item">
                                            <h5>自由裁量</h5>
                                                <el-input v-model="item.zycl" type="textarea" @input="renew($event)"
                                                :autosize="{minRows: 3, maxRows: 4}" ></el-input>
                                                <a class="fuzhi" @click="getText(item.zycl)"><i></i></a>
                                                <a class="fangda" @click="getBig(item.zycl)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                            <el-form-item label="">
                                                <h5>拟予处罚</h5>
                                                <el-input v-model="item.nycf" type="textarea" @input="renew($event)"
                                                    :autosize="{minRows: 3, maxRows: 4}" ></el-input>
                                                    <a class="fuzhi" @click="getText(item.nycf)"><i></i></a>
                                                    <a class="fangda" @click="getBig(item.nycf)"><img src="@/assets/images/big.png"></a>
                                            </el-form-item>
                                            </el-col>
                                        </el-row>
                                        </el-tab-pane>
                                        <el-tab-pane name="add" class="more-btn">
                                            <span slot="label">
                                                <el-button type="cyan" icon="el-icon-plus" size="mini" @click="add_wfqx">新增</el-button>
                                            </span>
                                        </el-tab-pane>
                                    </el-tabs>
                                    <el-form-item label="">
                                        <h5>主体资格证据</h5>
                                        <el-input v-model="form2.ajdcbg.ztzgzj" type="textarea" @input="renew($event)"
                                            :autosize="{minRows: 3, maxRows: 4}" ></el-input>
                                        <a class="fuzhi" @click="getText(form2.ajdcbg.ztzgzj)"><i></i></a>
                                        <a class="fangda" @click="getBig(form2.ajdcbg.ztzgzj)"><img src="../../../assets/images/big.png"></a>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <h5>违法事实证据</h5>
                                        <el-input v-model="form2.ajdcbg.wfsszj" type="textarea" @input="renew($event)"
                                            :autosize="{minRows: 3, maxRows: 4}" ></el-input>
                                        <a class="fuzhi" @click="getText(form2.ajdcbg.wfsszj)"><i></i></a>
                                        <a class="fangda" @click="getBig(form2.ajdcbg.wfsszj)"><img src="../../../assets/images/big.png"></a>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <h5 style="overflow:hidden;">处罚审批 <el-button type="primary" size="mini" @click="getHebing(form2.ajdcbg.data)" style="float:right;margin-top: 5px;">合并</el-button></h5>
                                        <p>
                                        <el-checkbox v-model="form2.jinggao" true-label="1"  false-label="0">警告</el-checkbox>
                                        <el-checkbox v-model="form2.tongbao" true-label="1"  false-label="0">通报批评</el-checkbox>
                                        <el-checkbox v-model="form2.fakuan" true-label="1"  false-label="0">
                                            <span>罚款</span>
                                            <el-input v-model="form2.fakuanJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                            :disabled="form2.fakuan != '1'" @input="form2.fakuanJine=form2.fakuanJine.replace(/[^\d.]/g,'')"></el-input>
                                            <span>元</span>
                                        </el-checkbox>
                                        <el-checkbox v-model="form2.moshouweifasuode" true-label="1"  false-label="0">
                                            <span>没收违法所得</span>
                                            <el-input v-model="form2.moshouweifasuodeJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                            :disabled="form2.moshouweifasuode != '1'" @input="form2.moshouweifasuodeJine=form2.moshouweifasuodeJine.replace(/[^\d.]/g,'')"></el-input>
                                            <span>元</span>
                                        </el-checkbox>
                                        <el-checkbox v-model="form2.diaoxiao" true-label="1"  false-label="0">
                                            <span>吊销</span>
                                            <el-input v-model="form2.diaoxiaoName" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                            :disabled="form2.diaoxiao != '1'"></el-input>
                                        </el-checkbox>
                                        <el-checkbox v-model="form2.zeling" true-label="1"  false-label="0">
                                            <span>责令</span>
                                            <el-input v-model="form2.zelingName" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                            :disabled="form2.zeling != '1'"></el-input>
                                        </el-checkbox>
                                        <el-checkbox v-model="form2.moshouwupin" true-label="1"  false-label="0">
                                            <span>没收（物品）</span>
                                            <el-input v-model="form2.moshouwupinName" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                            :disabled="form2.moshouwupin != '1'" ></el-input>
                                        </el-checkbox>
                                        <el-checkbox v-model="form2.jiangdizizhidengji" true-label="1"  false-label="0">降低资格等级</el-checkbox>
                                        </p>
                                    </el-form-item>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="6">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="text">文书</span>
                    </div>
                    <div class="box-cont">
                        <!--<div class="demo-input-suffix">
                            <el-input class="search"
                                placeholder="请输入文书名称查询"
                                v-model="wsName">
                                <i slot="suffix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>-->
                        <ul>
                            <li v-for="(item,index) in wsList" :key="index" @click="makeWenshu(item.wsNameSx,item.wsName,item.wsStatus)">
                                <p>
                                    <span>{{item.wsName}}</span>
                                    <i v-if="item.wsStatus == 1" class="el-icon-document"></i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="文书内容" :visible.sync="open2" width="600px" append-to-body :close-on-click-modal="false">
            <p style="white-space: pre-line">{{ bigText }}</p>
        </el-dialog>

        <el-dialog :title="title4" :visible.sync="open4" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <anyou :leixing="this.leixing2" :text="this.title4" :lshId="this.xcblLsh" @handleBack="handleBackAnyou" @closeTk="closeAnyou"  />
        </el-dialog>


        <el-dialog :title="titleWs" :visible.sync="openWs" top="5vh" :width="width" append-to-body :close-on-click-modal="false" @close='closeDialog'>
            <xwbl v-if="this.code.indexOf('xwbl') != -1" :code="this.code" :pcId="this.ajId" :mid="this.form1.mid" :xwSf="this.xwSf" :xwKey="xwKey" :xwText="this.xwText" :xwShuji="this.xwShuji" :form1="this.form1" :jdy1="this.jdy1" :jdy2="this.jdy2" :zfzh1="this.zfzh1" :zfzh2="this.zfzh2" @handleBack="handleBack" :key="Math.round()"  />
            <ajsl v-else-if="this.code == 'ajsl'" :code="this.code" :ajsl="this.form2.ajsl" :mid="this.form1.mid" :pcId="this.ajId" @handleBack="handleBack"  />
            <ajla v-else-if="this.code == 'ajla'" :code="this.code" :ajla="this.form2.ajla" :ajdcbg="this.form2.ajdcbg" :mid="this.form1.mid" :pcId="this.ajId" :ajlaList="this.form2.ajlaList" :jdy1="this.jdy1" :jdy2="this.jdy2" @handleBack="handleBack"  />
            <ajdcbg v-else-if="this.code == 'ajdcbg'" :code="this.code" :mid="this.form1.mid" :clyj="this.form2.clyj" :ajdcbgList="this.form2.ajdcbgList" :ajlaList="this.form2.ajlaList" :ajdcbg="this.form2.ajdcbg" :anyou="this.form2.reason2" :pcId="this.ajId" @handleBack="handleBack"  />
            <xcbl v-else-if="this.code == 'xcbl'" :code="this.code" :xcblZt="this.xcblZt" :form1="this.form1" :dwmc="this.form1.dwmc" :mid="this.form1.mid" :fr="this.form1.fr" :pcId="this.ajId" :xcbl1="this.form2.xcbl1"  :xcbl2="this.form2.xcbl2" :xcblList="this.form2.xcblList" @handleBack="handleBack"  />
            <jdyjs v-else-if="this.code == 'jdyjs'" :code="this.code"   :xcjczjTags="this.xcjczjTags"  :pcId="this.ajId" :xcblList="this.form2.xcblList" :mid="this.form1.mid" :anyou="this.form2.reason2" :jdyjs="this.form2.jdyjs" :jdyjsList="this.form2.jdyjsList" @handleBack="handleBack"  />
            <xzcfsxgzs v-else-if="this.code == 'xzcfsxgzs'" :gzsclyj="this.form2.gzsclyj" :xzcfsxgzsList="this.form2.xzcfsxgzsList" :code="this.code" :form1="this.form1" :pcId="this.ajId" :ajdcbgList="this.form2.ajdcbgList" @handleBack="handleBack"  />
            <xzcfsxgzsspb v-else-if="this.code == 'xzcfsxgzsspb'" :xzcfsxgzsspbList="this.form2.xzcfsxgzsspbList" :anyou="this.form2.reason2" :code="this.code" :pcId="this.ajId"  :mid="this.form1.mid" :xwbl="this.form2.xwbl" :ajdcbg="this.form2.ajdcbg" @handleBack="handleBack"  />
            <xzcfjds v-else-if="this.code == 'xzcfjds'"   :jdsclyj="this.form2.jdsclyj" :code="this.code" :xzcfjdsList="this.form2.xzcfjdsList" :pcId="this.ajId" :ajdcbgList="this.form2.ajdcbgList" @handleBack="handleBack"  />
            <xzcfspb v-else-if="this.code == 'xzcfjdsspb'" :code="this.code" :xzcfjdsspbList="this.form2.xzcfjdsspbList" :anyou="this.form2.reason2" :pcId="this.ajId"  :mid="this.form1.mid" :xwbl="this.form2.xwbl" :ajdcbg="this.form2.ajdcbg" @handleBack="handleBack"  />

            <span v-else>开发中...</span>
        </el-dialog>


        <el-dialog v-loading="loadingWord" title="询问笔录" :visible.sync="dialogFormVisible">
            <el-form>
                <el-form-item label="询问笔录：" label-width="100px">
                    <el-select v-model="xwblIndex" placeholder="" size="small"  style="width:200px; margin-right:20px;">
                        <el-option
                            v-for="(dict,index) in blOptions"
                            :key="dict.id"
                            :label="dict.wsName"
                            :value="index"
                            ></el-option>
                    </el-select>
                    <el-button size="small" type="warning" @click="showWenshuBl(xwblIndex)" icon="el-icon-document">查看</el-button>
                    <el-button size="small" type="danger" @click="addWenshuBl('xwbl')" icon="el-icon-plus">添加询问笔录</el-button>
                </el-form-item>
            </el-form>

            <!--<p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
            <p style="margin-bottom:20px;">
                <el-button size="small" type="danger" @click="edit3()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                <el-button size="small" type="primary" @click="resetWord3()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                
            </p>-->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>


        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>推理中...</p>
        </div>

        <el-dialog title="现场笔录" :visible.sync="xcblOpen" @close='closeDialog2'>
            <p style="margin-bottom:20px;">
                <el-button size="small" :type="isBL1 ? 'primary' : 'danger'" @click="makeXcbl(1)" :icon="isBL1 ? 'el-icon-document' : 'el-icon-plus'">{{isBL1 ? '查看' : '添加'}}现场笔录（首次）</el-button>&nbsp;&nbsp;
                <el-button size="small" :type="isBL2 ? 'primary' : 'danger'" @click="makeXcbl(2)" :icon="isBL2 ? 'el-icon-document' : 'el-icon-plus'">{{isBL2 ? '查看' : '添加'}}现场笔录（复查）</el-button>&nbsp;&nbsp;    
            </p>
        </el-dialog>


        <el-dialog title="填写文件名" :visible.sync="dialogVisible" width="50%">
            <div v-if="currentFileList && currentFileList.length > 1">
                <p>请为每个文件输入文件名：</p>
                <el-form>
                    <el-form-item 
                        v-for="(file, index) in currentFileList" 
                        :key="index" 
                        :label="'文件 ' + (index + 1)"
                        :label-width="'80px'"
                    >
                        <el-input 
                            v-model="fileNamesList[index]" 
                            :placeholder="'请输入文件名（原文件名: ' + (file.name || (file.fileName)) + '）'"
                            size="small"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-else>
                <el-input v-model="fileNameSc" placeholder="请输入文件名"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmUpload">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import anyou from './anyou.vue'
import axios from 'axios'
import qs from 'qs'

import xwbl from './wslb/xwbl.vue'
import ajsl from './wslb/ajsl.vue'
import ajla from './wslb/ajla.vue'
import ajdcbg from './wslb/ajdcbg.vue'
import xcbl from './wslb/xcbl.vue'
import jdyjs from './wslb/jdyjs.vue'
import xzcfsxgzs from './wslb/xzcfsxgzs.vue'
import xzcfsxgzsspb from './wslb/xzcfsxgzsspb.vue'
import xzcfjds from './wslb/xzcfjds.vue'
import xzcfspb from './wslb/xzcfspb.vue'

export default {
    name: "znxq",
    props:['dwId','dwInfo','isSl'],
    data() {
        return {
            isZhedie:false,
            activeName:'first',
            activeName2:'1',
            loading:false, 
            dm:'',
            xm:'',
            cmid:'',
            jcjg:'',
            dwForm:{},
            xkzText:'许可证号',
            form:{},
            options:[],
            options2:[],
            dqIndex:0,
            wfqx_tab: [{
                title: '违法事实1',
                name:'1',
                id: 0,
                ay:'',
                wfxw:'',
                wffl:'',
                cfyj:'',
                zycl:'',
                nycf:'',
                ztzgzj:'',
                wfsszj:''
            }],
            wfqx_val:'0',

            form1:{},
            form2:{
                xcbl1:'',
                xcbl2:'',
                xwbl1:'',
                xwbl2:'',
                reason1:'',
                reason2:'',
                reason22:'',
                Hreason22:'',
                jdyjs:'',
                xwbl:'',
                ajsl:'',
                ajla:'',
                jhxdczs:'',
                xzcfsxgzs:'',
                xzcfjds:'',
                xzcfspb:'',
                domains:[],
                jinggao:'0',
                tongbao:'0',
                fakuan:'0',
                fakuanJine:'',
                moshouweifasuode:'0',
                moshouweifasuodeJine:'',
                diaoxiao:'0',
                zeling:'0',
                moshouwupin:'0',      
                jiangdizizhidengji:'0',
                diaoxiaoName:'',
                zelingName:'',
                moshouwupinName:'',
                clyj:'',
                gzsclyj:'',
                jdsclyj:'',
                ajdcbg:{
                    jhxdczs:'',
                    ztzgzj:'',
                    wfsszj:'',
                    data:[{
                        ay:'',
                        wfxw:'',
                        wffl:'',
                        cfyj:'',
                        zycl:'',
                        nycf:'',              
                    }] 
                }              
            },
            xbOptions:[
                {id:1,label:'男'},
                {id:2,label:'女'}
            ],
            jingyingzheOptions:[],
            mzOptions:[],
            zwOptions:[],
            lyOptions:[],
            ksOptions:[],
            userOptions:[],
            dhOptions:[],
            whpreOptions:[],
            aj_list:[],
            open:false,

            cfCheck:[],
            open:false,
            bigText:'',
            open2:false,
            manualTags: [],  // 手动添加的标签
            gjcTags: [],     // 合并后的所有标签
            otherGjc:'',
            tlmbContent:'',
            tlmbResult:'',
            isEditable:false,
            isQueding:false,
            loadingR:false,
            text:'',
            xcblLsh:'',
            templateId:'',
            tlIndex:0,
            loadingTl:false,
            isAy:1,
            isCay:false,
            open4:false,
            title4:'',
            leixing2:'',
            openWs:false,
            titleWs:'',
            code:'',
            ajId:'',
            width:'1000px',

            dialogFormVisible:false,
            loadingWord:false,
            blOptions:[],
            xwblUrl:'',
            xwblIndex:0,
            jdy1:'',
            jdy2:'',
            zfzh1:'',
            zfzh2:'',
            xunwenList: [
                { name: '1', key: 'xwbl1',nr:'',wsName:'询问笔录1' },
                { name: '2', key: 'xwbl2',nr:'',wsName:'询问笔录1' }
            ],
            nextXwblIndex: 3, // 下一个要生成的索引
            xwSf:'',
            xwKey:-1,
            xwText:'',
            xwShuji:{},

            fileNames:'',

            ztzgzjTags:[],
            wfsszjTags:[],
            xcjczjTags:[],
            ayIndex:-1,
            isZt:0,
            baseUrl:'',
            wsList:[],
            xcblOpen:false,
            xcblZt:'1',
            isBL1:false,
            isBL2:false,

            loadingxcjc:false,
            xcjcList:[],

            dialogVisible: false,
            fileNameSc: '',
            currentFile: null,
            currentFileList: [],
            fileNamesList: [],
        }
    },
    components: {
        anyou,
        ajsl,
        ajla,
        ajdcbg,
        xwbl,
        xcbl,
        jdyjs,
        xzcfsxgzs,
        xzcfsxgzsspb,
        xzcfjds,
        xzcfspb,
    },
    // 添加 created 钩子
    created() {
    },
    async mounted() {
        console.log(this.dwInfo,668)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.xm = user.xm 
        this.cmid = user.c_mid
        this.wenhao =  user.wenhao
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/selectFaRenType`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data,1194)
            if (response.data && response.data.data) {
                this.jingyingzheOptions = response.data.data || [];
            }
            this.loading = false
        })
        .catch(error => {
            this.loading = false
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions =  res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        }) 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getjbks`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.ksOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(async response => {
            this.userOptions = response.data.data || []
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   
        this.getList()
    },
    watch: {
        'form.xiaolei': {
            handler(newVal) {
                const selectedTags = Array.isArray(newVal) ? newVal : [];
                this.gjcTags = [...new Set([...selectedTags, ...this.manualTags])];
            },
            deep: true
        }
    },
    methods: {
        zhedie(){
            this.isZhedie = !this.isZhedie
        },
        handleGetTuili(val,num) {
            if(!this.xcblLsh){
                this.$message.error('请先暂存案件数据！');
                return false
            }
            if(!this.ztzgzjTags || this.ztzgzjTags.length == 0){
                this.$message.error('请先上传主体资格证据！');
                return false
            }
            if(!this.wfsszjTags || this.wfsszjTags.length == 0){
                this.$message.error('请先上传违法事实证据！');
                return false
            }
            if(!this.form2.reason2){
                this.$message.error('请先选择案由！');
                return false
            }
            if (this.tlIndex === 0) {
                if(val == 'xwbl'){
                    this.$prompt('请输入被询问人身份', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({ value }) => {
                        this.getTuiliXwbl(val,value,'1');
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消输入'
                        });       
                    });
                }else{
                    this.getTuili(val,num);
                }
            }else{
                this.$message.error('推理中请勿重复点击！');
            }
        },
        getTuili(val,num,value){
            this.tlIndex = num
            this.loadingTl = true
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/otherInferences`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    mid:this.form1.mid,
                    lsh:this.xcblLsh,
                    templateName:val
                }
            })
            .then(response => {
                console.log(response.data,1081);
                if(response.data.code == 0 && response.data.data){
                    this.form2[val] = response.data.data.answer;
                    this.setLiucheng(num)
                    if(val == 'xwbl'){
                        if(this.activeName2 == '1'){
                            this.$set(this.form2,'xwbl1',response.data.data.answer)
                        }else if(this.activeName2 == '2'){
                            this.$set(this.form2,'xwbl2',response.data.data.answer)
                        }
                    }else if(val == 'ajdcbg'){
                        
                        if(this.ztzgzjTags){
                            let str = ''
                            console.log(this.ztzgzjTags,1048);
                            for(let i = 0;i<this.ztzgzjTags.length;i++){
                                str += (i+1)+'、'+this.removeFileExtension(this.ztzgzjTags[i].fileName)+(i<this.ztzgzjTags.length-1?';\n':';');
                            }
                            console.log(str,1052);
                            this.$set(this.form2.ajdcbg,'ztzgzj',str)
                            console.log(this.form2.ajdcbg.ztzgzj,1054);
                        }
                        if(this.wfsszjTags){
                            let str2 = ''
                            console.log(this.wfsszjTags,1057);
                            for(let i = 0;i<this.wfsszjTags.length;i++){
                                str2 += (i+1)+'、'+this.removeFileExtension(this.wfsszjTags[i].fileName)+(i<this.wfsszjTags.length-1?';\n':';');
                            }
                            console.log(str2,1061);
                            this.$set(this.form2.ajdcbg,'wfsszj',str2)
                            console.log(this.form2.ajdcbg.wfsszj,1064);
                        }

                    }
                }else{
                    this.$message.error(response.data.msg);
                }
                this.loading = false
                this.tlIndex = 0
                this.loadingTl = false
                this.save(0)
            })
            .catch(error => {
                this.loading = false
                this.tlIndex = 0
                this.loadingTl = false
                this.$message.error('推理失败！'|| error);
                console.error('There was an error!', error);
            });
        },
        getTuiliXwbl(val,value,index){
            this.loadingTl = true
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/otherInferences`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    beixunwenrensf:value,
                    mid:this.form1.mid,
                    lsh:this.xcblLsh,
                    templateName:val
                }
            })
            .then(response => {
                console.log(response.data,1081);
                if(response.data.code == 0 && response.data.data){
                    this.titleWs = '询问笔录'+index
                    this.xwText = response.data.data.answer
                    this.$set(this.form2,'xwbl'+index,response.data.data.answer)

                    this.xunwenList.push({name:index,key:'xwbl'+index,nr:response.data.data.answer,wsName:'询问笔录'+index})
                    this.xwSf = value
                    this.xwKey = index
                    this.code = 'xwbl'+index
                    console.log(this.xwSf,this.xwText,this.xwKey)
                    this.openWs = true; // 打开文书编辑弹窗
                }else{
                    this.$message.error(response.data.msg);
                }
                this.loading = false
                this.loadingTl = false
            })
            .catch(error => {
                this.loading = false
                this.loadingTl = false
                this.$message.error('询问笔录推理失败！'|| error);
                console.error('There was an error!', error);
            });
        },
        getBig(text){
            this.bigText = text
            this.open2 = true
        },
        setLiucheng(val){
            this.$forceUpdate()
            this.dqIndex = val
        },
        setActive(val){
            this.activeName = val
        },
        setActive2(val,num,index){
            console.log(val,num,index,1336)
            this.activeName2 = index
            this.xwKey = index
            this.ajId = this.xcblLsh
            if(this.xunwenList[index - 1].nr){
                this.titleWs = '询问笔录'+index
                this.code = 'xwbl'+index
                this.xwKey = index
                this.xwText = this.xunwenList[index - 1].nr
                this.xwSf = this.xunwenList[index - 1].sf
                this.xwShuji = this.xunwenList[index - 1]
                this.openWs = true; // 打开文书编辑弹窗
            }else{
                this.xwShuji = {}
                this.$prompt('请输入被询问人身份', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.getTuiliXwbl(val,value,index);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            }
        },
        makeWenshuBl(val, text, wsStatus) {
            this.titleWs = text;
            this.code = val;
            this.ajId = this.xcblLsh;
            this.xwShuji = {}
            if (wsStatus == 0) {
                this.addWenshuBl(val)
            } else {
                this.show2('询问笔录')
            } 
        },
        addWenshuBl(val){
            this.xwShuji = {}
            let length = this.blOptions.length;
            let targetKey = length + 1;
            console.log(this.blOptions,targetKey, 1053)
            this.$prompt('请输入被询问人身份', '询问笔录'+targetKey, {
                confirmButtonText: '推理',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                this.getTuiliXwbl(val,value,targetKey);
            }).catch(() => {
                this.$message.info('取消输入');
            });
        },
        showWenshuBl(index){
            console.log(this.xunwenList[index])
            this.xwKey = index
            this.ajId = this.xcblLsh
            this.titleWs = '询问笔录'+index
            this.code = 'xwbl'+index
            this.xwKey = index
            this.xwText = this.xunwenList[index].nr
            this.xwSf = this.xunwenList[index].sf
            this.xwShuji = this.xunwenList[index]
            this.openWs = true; // 打开文书编辑弹窗
        },
        change_wfqx(tab, event){
            if(tab == 'add'){
                return false;
            }
        },
        add_wfqx(){
            let newTabName = String(this.form2.ajdcbg.data.length)
            this.form2.ajdcbg.data.push({
                ay:'',
                wfxw:'',
                wffl:'',
                cfyj:'',
                zycl:'',
                nycf:'', 
            })
            this.wfqx_val = newTabName 
            console.log(this.wfqx_val,741)
            console.log(this.form2.ajdcbg,1050)
        },
        removeTab(targetName) {
            console.log(targetName, 1350)
            let tabs = this.form2.ajdcbg.data;
            let activeName = this.wfqx_val;

            if (tabs.length === 1) {
                this.$message.error('至少要有一个违法事实');
                return;
            }

            let str = '确定要删除该违法事实吗？删除后将不能恢复';

            this.$confirm(str, '提示', {
                confirmButtonText: '取消',
                cancelButtonText: '确定',
                type: 'warning',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).catch(() => {
                const indexToRemove = Number(targetName); // 将 targetName 转为数字索引
                if (!isNaN(indexToRemove) && tabs[indexToRemove]) {
                    tabs.splice(indexToRemove, 1); // 直接通过索引删除
                }

                // 如果当前 activeName 是被删除的 tab，则更新 activeName
                if (Number(activeName) === indexToRemove) {
                    this.wfqx_val = String(Math.min(indexToRemove, tabs.length - 1));
                }

                console.log(this.form2.ajdcbg, 1071);
            });
        },
        addXcbj(){
            this.text = this.activeName == 'first' ? '现场笔录1' : '现场笔录2'
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/firstLevel`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {}
            })
            .then(response => {
                console.log(response.data);
                this.options = response.data.data
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
            this.form = {}
            this.manualTags = []
            this.gjcTags = []  
            this.otherGjc = ''
            this.tlmbContent = ''
            this.tlmbResult = ''
            this.isQueding = false
            this.loadingR = false
            this.open = true
        },
        
        shengcheng(){},
        onSubmit(){},
        quxiao(){
            this.open = false
            this.form = {}
        },
        //原来的
        renew(e){
            this.$forceUpdate()
        },    
        getBack(){
            let that = this
            this.$confirm("您是否确定当前页面数据已保存吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                that.$emit('handleBack',1)
            })
        },
        //复制文字
        getText(text){
            // var e = text;
            // e.select();
            // document.execCommand("Copy");
            let msg = text+''
            let that = this
            this.$copyText(msg).then(function (e){
                console.log(e)
                that.$message.success('复制成功')
            })
        },
        //暂存
        async save(val){
   
            console.log(val)
            console.log(this.form2,1502)
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/saveAndStore`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh:this.xcblLsh,
                    xcbl1:this.form2.xcbl1,
                    mid:this.form1.mid,
                    xcbl2:this.form2.xcbl2,
                    status:val,
                    jdyjs:this.form2.jdyjs,
                    xwbl:this.form2.xwbl,
                    ajsl:this.form2.ajsl,
                    ajla:this.form2.ajla,
                    reason1:this.form2.reason1,
                    reason2:this.form2.reason2,
                    reason22:this.form2.reason22,
                    hreason22:this.form2.Hreason22,
                    jinggao:this.form2.jinggao,
                    tongbao:this.form2.tongbao,
                    fakuan:this.form2.fakuan,
                    fakuanJine:this.form2.fakuanJine,
                    moshouweifasuode:this.form2.moshouweifasuode,
                    moshouweifasuodeJine:this.form2.moshouweifasuodeJine,
                    diaoxiao:this.form2.diaoxiao,
                    zeling:this.form2.zeling,
                    moshouwupin:this.form2.moshouwupin,        
                    jiangdizizhidengji:this.form2.jiangdizizhidengji,
                    diaoxiaoName:this.form2.diaoxiaoName,
                    zelingName:this.form2.zelingName,
                    moshouwupinName:this.form2.moshouwupinName,  
                    ajdcbg:this.form2.ajdcbg,
                    xzcfsxgzs:this.form2.xzcfsxgzs,
                    xzcfsxgzsspb:this.form2.xzcfsxgzsspb,
                    xzcfjds:this.form2.xzcfjds,
                    xzcfjdsspb:this.form2.xzcfjdsspb,
                }
            })
            .then(response => {
                console.log(response.data,1165);
                this.$message({
                    message: val== 0 ? '暂存成功' : '保存成功',
                    type: 'success'
                });

                if(response.data.code==0){
                    this.xcblLsh=response.data.msg
                }
                this.getXq()
                if(val == 1){
                    this.$router.push({ path: '/znlb' });
                }
            })
            .catch(error => {
                this.$message.error(error);
                console.error('There was an error!', error);
            });
        },
        handleSubmit(){
            this.$confirm('点击保存后不能在修改案件信息，请谨慎操作！', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '放弃修改'
            })
            .then(() => {
                this.save(1)
            })
            .catch(action => {
                this.$message({
                type: 'info',
                message: action === 'cancel'
                    ? '放弃保存并离开页面'
                    : '停留在当前页面'
                })
            });
        },
        //案由处理
        getAnyou(text,val,index){
            console.log(index,1477)
            this.ayIndex = index !== undefined ? index : -1;
            this.title4 = text
            this.open4 = true
            this.leixing2 = val
        },
        delectAnyou(index){
            this.form2.domains.splice(index,1)
        },
        //增加从案由
        addAy(){
            this.isCay = true
        },
        addAnyou(){
            this.isAy = this.form2.domains.length > 0 ? this.form2.domains[this.form2.domains.length - 1].key+1 : this.isAy + 1
            console.log(this.isAy,1492)
            this.form2.domains.push({value:'',key:this.isAy})
            console.log(this.form2.domains)
        },
        delectReason22(){
            this.$set(this.form2,'reason22','')
            this.$set(this.form2,'Hreason22','')
            this.isCay = false
        },
        delectAnyou(index,id){
            this.form2.domains.splice(index,1)
            console.log(id)
            if(id){
                this.deleAn(id)
            }
        },
        deleAn(id){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/delAnYou`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id:id,
                }
            })
            .then(response => {
                console.log(response.data,1520);
                this.getXq()
            })
            .catch(error => {
                this.$message.error(error);
                console.error('There was an error!', error);
            });
        },
        //案由弹窗返回内容
        handleBackAnyou(data,val){
            console.log(this.ayIndex,this.leixing2,this.form2.reason2,this.form2.reason22,this.form2.domains)
            if(val == 1){
                if(this.form2.reason2 && this.form2.reason2 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    this.form2.reason2 = data
                    this.save(0)
                    //this.saveAnyou(data,val)
                    this.open4 = false
                }
            }else{
                
                if(this.form2.reason22 && this.form2.reason22 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    if(this.ayIndex == -1){
                        this.form2.reason22 = data
                        this.save(0)
                        //this.saveAnyou(data,val)
                    }else{
                        console.log(this.ayIndex,this.form2.domains)
                        this.form2.domains[this.ayIndex].value = data
                        this.saveAnyou(data,val)
                    }
                    
                    this.open4 = false
                }
            }
        },
        saveAnyou(data,val){
            console.log(data,val,1535)
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/saveUpdateAnYou`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh:this.xcblLsh,
                    anyouType:val,
                    anyou:data,
                    id:"",
                }
            })
            .then(response => {
                console.log(response.data,1165);
                if(response.data.code != 0){
                    this.$message.error(response.data.msg);
                }else{
                    this.getXq()
                }
            })
            .catch(error => {
                this.$message.error(error);
                console.error('There was an error!', error);
            });
        },
        closeAnyou(data){
            this.open4 = false
        },
        getHbAnyou(){
            console.log(this.form2.reason2,this.form2.reason22)
            this.$set(this.form2,'Hreason22','')
            axios({
                method: 'post',
                url: this.baseUrl+`/login/hebinganyou`,
                data:{
                    anyou1:this.form2.reason2,
                    anyou2:this.form2.reason22
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.msg){
                    this.$set(this.form2,'Hreason22',res.data.msg)
                    this.save(0)
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        //获取案件信息
        getList(){
            this.loading = true
            console.log(1607,this.xcblLsh,this.isSl)
            this.wfqx_val = '0'
            this.isBL1 = false
            this.isBL2 = false
            if(this.$route.query.lsh){
                this.xcblLsh = this.$route.query.lsh
                console.log(this.xcblLsh,1059)
                this.isZt = this.$route.query.status
                let form = JSON.parse(sessionStorage.getItem("ajxq"));
                this.dwInfo = form
                if(this.dwInfo){                    
                    this.form1 = this.dwInfo
                    //this.dwForm = Object.assign({}, this.dwInfo);
                    if(this.dwInfo.zylbId == '06'){
                        this.xkzText = '医疗机构职业许可证号:'
                    }else if(this.dwInfo.zylbId == '04'){
                        this.xkzText = '放射诊疗许可证号:'
                    }else{
                        this.xkzText = '许可证号:'
                    }
                console.log(this.$route,1063)
                    this.getXq()
                }else{
                    this.form1 = {}
                    this.xkzText = '许可证号:'
                }
                this.getWslb()
            }else{
                let form = JSON.parse(sessionStorage.getItem("ajxq"));
                this.dwInfo = form
                if(this.dwInfo){
                    this.form1 = this.dwInfo
                    this.form2.reason1 = this.form1.dwmc
                    //this.dwForm = Object.assign({}, this.dwInfos);
                    if(this.dwInfo.zylbId == '06'){
                        this.xkzText = '医疗机构职业许可证号:'
                    }else if(this.dwInfo.zylbId == '04'){
                        this.xkzText = '放射诊疗许可证号:'
                    }else{
                        this.xkzText = '许可证号:'
                    }
                    if(this.isNew == 1){
                        this.$set(this.form2,'reason1',this.dwInfo.dwmc)
                        this.$set(this.form2,'host_man',this.xm)
                        this.$set(this.form2,'factHost',this.xm)
                        this.text1 = '许可证'
                        this.text2 = '责令停产停业'
                    }
                }else{
                    this.form1 = {}
                    this.xkzText = '许可证号:'
                }
                this.getWslb()
            }
            
        },
        getWslb(){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/wsListName`,
                data:{
                    lsh:this.xcblLsh,
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.wsList = res.data.data
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        getXq(){
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/detailsData`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh:this.xcblLsh,
                    mid:this.form1.mid,
                }
            })
            .then(response => {
                console.log(response.data,1194)
                this.isBL1 = false
                this.isBL2 = false
                if (response.data && response.data.data) {
                    let obj = response.data.data;
                    if (obj !== null) { // 判断 obj 不为 null
                        if (obj.xcblList && obj.xcblList.length >= 1) {
                            this.jdy1 = obj.xcblList[0].zhubanrenyuan || ''
                            this.jdy2 = obj.xcblList[0].xiebanrenyuan || ''
                            this.zfzh1 = obj.xcblList[0].zfzh1 || ''
                            this.zfzh2 = obj.xcblList[0].zfzh2 || ''
                        }
                        this.form2 = Object.assign({}, this.form2, obj);
                        if(!obj.ajdcbg.data || obj.ajdcbg.data.length == 0){
                            this.form2.ajdcbg.data =
                                [{
                                    ay:'',
                                    wfxw:'',
                                    wffl:'',
                                    cfyj:'',
                                    zycl:'',
                                    nycf:'',              
                                }] 
                        }
                        // 确保默认激活第一个标签页
                        this.wfqx_val = '0';
                        if(obj.anyouList && obj.anyouList.length > 0) {
                            let arr = obj.anyouList                                
                            this.form2.domains = arr.map((item,index) => {                                   
                                return {
                                    value: item.anyou,
                                    id: item.id,
                                    key: index + 2
                                }
                            });
                            console.log(this.form2.domains,1646)
                            this.isAy = this.form2.domains.length + 1
                        }
                        if (obj.xcblList && obj.xcblList.length > 0) {
                            let arr = obj.xcblList
                            arr.forEach(item => {
                                if(item.record_status == '2'){
                                    this.$set(this.form2,'xcbl2',item.inspectionContent)
                                    this.isBL2 = true
                                }else if(item.record_status == '1'){
                                    this.$set(this.form2,'xcbl1',item.inspectionContent)
                                    this.isBL1 = true
                                }
                            })
                        }else{
                            this.$set(this.form2,'xcbl1',obj.xcbl1 || '')
                            this.$set(this.form2,'xcbl2',obj.xcbl2 || '')
                        }
                        if (obj.xwblList && obj.xwblList.length > 0) {
                            // 清空默认的 xunwenList，准备填充数据
                            this.xunwenList = [];

                            // 遍历 obj.xwblList 中的所有元素，并一一映射到 this.xunwenList
                            for (let i = 0; i < obj.xwblList.length; i++) {
                                console.log(obj.xwblList[i],1602)
                                this.xunwenList.push({
                                    name: i + 1,
                                    key: 'xwbl' + (i + 1),
                                    nr: obj.xwblList[i].tuilineirong || '',
                                    wsName: obj.xwblList[i].wsName || '询问笔录' + (i + 1),
                                    ...obj.xwblList[i]
                                });
                            }

                            // 如果不足两个，默认补一个空对象
                            while (this.xunwenList.length < 2) {
                                this.xunwenList.push({
                                    name: this.xunwenList.length + 1,
                                    wsName:'询问笔录'+(this.xunwenList.length + 1),
                                    key: 'xwbl' + (this.xunwenList.length + 1),
                                    nr: ''
                                });
                            }
                        } else {
                            // 如果 obj.xwblList 不存在或为空，默认初始化两个空对象
                            this.xunwenList = [
                                {
                                    name: 1,
                                    key: 'xwbl1',
                                    nr: '',
                                    wsName:'询问笔录1'
                                },
                                {
                                    name: 2,
                                    key: 'xwbl2',
                                    nr: '',
                                    wsName:'询问笔录2'
                                }
                            ];
                        }

                        if(obj.cailiaozhengjuList && (obj.cailiaozhengjuList.selectUploadResOne || obj.cailiaozhengjuList.selectUploadResTwo || obj.cailiaozhengjuList.selectUploadResThree)) {
                            this.ztzgzjTags = obj.cailiaozhengjuList.selectUploadResOne || []
                            this.wfsszjTags = obj.cailiaozhengjuList.selectUploadResTwo || []
                            this.xcjczjTags = (obj.cailiaozhengjuList.selectUploadResThree || []).map(item => ({
                            ...item,
                            isEditing: false
                            }));
                        }
                    }
                }
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        makeWenshu(val,text,wsStatus){

            if(!this.xcblLsh || this.xcblLsh == ''){
                this.$message.error('请先暂存案件信息！')
                return false;
            }
        //    else if(val == 'jdyjs' 
        //    && (!this.form2.xcblList  || this.form2.xcblList.length == 0 ) 
        //    && (!this.xcjczjTags  || this.xcjczjTags.length == 0 ) ) {
        //     this.$message.error('请先制作"现场笔录"或上传现场笔录！');
        //         return false;
        //     }
         else if(val === 'jdyjs' && (this.form2.reason2 == null || this.form2.reason2.trim() === '')) {
            this.$message.error('请选择"主案由"！');
            return false;
        }
            //if(val == 'xwbl' && (!this.form2.jdyjsList || this.form2.jdyjsList.length == 0)){
                //this.$message.error('请先制作"监督意见书"！')
                //return false;
            //}
            //if(val == 'ajla' && (!this.form2.xwblList || this.form2.xwblList.length == 0)){
                //this.$message.error('请先制作"询问笔录"！')
                //return false;
            //}
            //if(val == 'ajdcbg' && (!this.form2.ajlaList || this.form2.ajlaList.length == 0)){
                //this.$message.error('请先制作"案件立案"！')
                //return false;
            //}
            //if(val == 'xzcfsxgzs' && (!this.form2.ajdcbgList || this.form2.ajdcbgList.length == 0)){
                //this.$message.error('请先制作"案件调查报告"！')
                //return false;
            //}
            //if(val == 'xzcfsxgzsspb' && (!this.form2.xzcfsxgzsList || this.form2.xzcfsxgzsList.length == 0)){
                //this.$message.error('请先制作"行政处罚事先告知书"！')
                //return false;
            //}
            //if(val == 'xzcfjds' && (!this.form2.xzcfsxgzsspbList || this.form2.xzcfsxgzsspbList.length == 0)){
                //this.$message.error('请先制作"行政处罚事先告知书审批表"！')
                //return false;
            //}
            //if(val == 'xzcfjdsspb' && (!this.form2.xzcfjdsList || this.form2.xzcfjdsList.length == 0)){
                //this.$message.error('请先制作"行政处罚决定书"！')
                //return false;
            //}
            this.titleWs = text
            this.code = val
         
            this.ajId = this.xcblLsh
            console.log(this.ajId,1605)
            if(val == 'cfajml' || val == 'zjxxdjbcjds'){
                this.width = '1200px'
            }else if(val == 'yjyzz'){
                this.width = '700px'
            }else{
                this.width = '1000px'
            }
            console.log(this.form2.xcblList,1585)
            console.log(this.form2.xzcfsxgzsList,1818)
            if(val == 'xwbl'){
                this.makeWenshuBl('xwbl','询问笔录',wsStatus)
            }else if(val == 'xcbl'){
                this.xcblOpen = true
            }else{
                this.openWs = true
            }
        },
        makeXcbl(value){
            console.log(value,this.isBL1,1677)
            if(value == 2 && !this.isBL1){
                this.$message.error('请先制作"现场笔录（首次）"！')
                return false;
            }
            this.titleWs = value == 1 ? '现场笔录（首次）' : '现场笔录（复查）'
            this.code = 'xcbl'
            console.log(this.ajId,1684)

         
            this.ajId = this.xcblLsh
            this.xcblZt = value
            this.openWs = true
        },
        handleBack(val,val2,val3){

            console.log(val,val2,val3,1610)
            //this.openWs = false
            this.xcblLsh = val3
            if(val2 == 2){
                this.$set(this.form2,'xcbl2',val)
            }else{
                this.$set(this.form2,'xcbl1',val)
            }
            this.$forceUpdate()
            console.log(this.form2.xcbl1,this.form2.xcbl2,1886)
            let num = this.isZt == 1 ? 1 : 0
            this.save(num)
        },
        closeDialog(){
            console.log(this.code)
            if(this.code.indexOf('xwbl') != -1){
                this.show2('询问笔录')
            }
            this.openWs = false
            this.getXq()
            this.getWslb()
        },
        closeDialog2(){
            this.getXq()
            this.getWslb()
            this.xcblOpen = false
        },
        show(wsName){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.xcblLsh,
                    wsName: wsName,
                }
            })
            .then(response => {
                console.log(response.data,1544);
                if(response.data.code==0){
                    if(response.data.msg){ 
                        let ws = response.data.msg
                        let url = this.$router.resolve({
                            path:'/pdf2',
                            query:{
                                ws:encodeURIComponent(ws) // 手动 encode 一次
                            }
                        })
                        window.open(url.href,'_blank')
                    }else{
                        this.$message.error(wsName+'文书未生成，请先生成再预览！')
                    }
                }else{
                    this.$message.error('文书未生成，请先生成再预览！')
                }
            })
            .catch(error => {
                this.$message.error('文书预览失败！');
                console.error('There was an error!', error);
            });          
        },
        show2(wsName){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectXwblWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.xcblLsh,
                    wsName: wsName,
                }
            })
            .then(response => {
                console.log(response.data,1544);
                if(response.data.code==0){
                    if(response.data.data && response.data.data.length > 0){ 
                        this.blOptions = response.data.data
                        this.xwblUrl = response.data.data[0].url
                        this.xwblIndex = 0
                        this.dialogFormVisible = true        
                    }else{
                        this.$message.error(wsName+'文书未生成，请先生成再预览！')
                    }
                }else{
                    this.$message.error('文书未生成，请先生成再预览！')
                }
            })
            .catch(error => {
                this.$message.error('文书预览失败！');
                console.error('There was an error!', error);
            });          
        },
        show3(){
            if(this.xwblUrl){
                let url = this.$router.resolve({
                    path:'/pdf2',
                    query:{
                        ws:encodeURIComponent(this.xwblUrl) // 手动 encode 一次
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('询问笔录文书预览失败，请联系管理员！');
            }
        },
        async resetWord3(){
            console.log(this.blOptions)
            this.loadingWord = true
            //重新生成文书
            let mid = this.form1.mid
            let lsh = this.xcblLsh
            let blLsh = this.blOptions[0].xwbl_lsh
            let wsname = 'xunwenbilu'+blLsh+'.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${mid}&lsh=${lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        //证据材料
        beforeUpload(file) {
            ///const isValidType = file.type === 'application/pdf' || file.name.endsWith('.pdf');
            //if (!isValidType) {
            //    this.$message.error('只能上传 PDF 文件');
            //    return false;
            //}
            return true;
        },
    // 在 methods 中添加以下方法
handleXcjcUpload(payload) {
    return this.customUpload(payload, 'xcjczj');
},
handleZtzgUpload(payload) {
    return this.customUpload(payload, 'ztzgzj');
},
handleWfssUpload(payload) {
    return this.customUpload(payload, 'wfsszj');
},
handleChange(file, fileList, field) {
    this.tlIndex =  field == 'ztzgzj' ? 10 : (field == 'wfsszj' ? 11 : 12);
    
    // 设置当前文件和文件列表
    this.currentFile = file.raw || file;  // 使用原始文件对象
    this.currentFileList = fileList.map(f => f.raw || f);  // 转换整个文件列表
    
    // 初始化文件名列表 - 保留完整文件名（包括扩展名）
    this.fileNamesList = this.currentFileList.map(f => {
        // 保留完整文件名，但去除扩展名让用户可以修改主体部分
        const fileName = f.name || (f.fileName);
        if (fileName) {
            const lastDotIndex = fileName.lastIndexOf('.');
            return lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
        }
        return '';
    });
    
    const names = fileList.map(f => f.name).filter(name => name.endsWith('.pdf'));
    const uniqueNames = [...new Set(names)]; // 去重
    // 单选时直接赋值为字符串，多选时逗号拼接
    this.fileNames = uniqueNames.length === 1 ? uniqueNames[0] : uniqueNames.join(',');
    
    // 对于单个文件，也去除扩展名显示在输入框中
    if (this.currentFileList.length === 1) {
        const singleFileName = this.currentFileList[0].name || (this.currentFileList[0].fileName);
        if (singleFileName) {
            const lastDotIndex = singleFileName.lastIndexOf('.');
            this.fileNameSc = lastDotIndex > 0 ? singleFileName.substring(0, lastDotIndex) : singleFileName;
        } else {
            this.fileNameSc = '';
        }
    } else {
        this.fileNameSc = this.fileNames;
    }
    
    this.dialogVisible = true;
    console.log(file, this.fileNames, 1580);
},
confirmUpload() {
    // 确保 currentFile 存在
    if (!this.currentFile) {
        this.$message.error('未选择文件或文件无效');
        return;
    }

    console.log(this.tlIndex, 1912);
    
    // 处理多个文件的情况
    if (this.currentFileList && this.currentFileList.length > 1) {
        // 检查是否所有文件都填写了文件名
        for (let i = 0; i < this.fileNamesList.length; i++) {
            if (!this.fileNamesList[i]) {
                this.$message.error(`请填写第 ${i + 1} 个文件的文件名`);
                return;
            }
        }
        
        // 为每个文件创建新的 File 对象并上传
        const uploadPromises = [];
        for (let i = 0; i < this.currentFileList.length; i++) {
            const file = this.currentFileList[i];
            let newFileName = this.fileNamesList[i]; // 用户输入的文件名
            
            // 如果用户输入的文件名不包含扩展名，则添加原文件的扩展名
            if (file.name) {
                const lastDotIndex = file.name.lastIndexOf('.');
                if (lastDotIndex > 0) {
                    const extension = file.name.substring(lastDotIndex);
                    // 检查用户输入的文件名是否已经包含扩展名
                    if (!newFileName.endsWith(extension)) {
                        newFileName = newFileName + extension;
                    }
                }
            }
            
            const updatedFile = new File([file], newFileName, {
                type: file.type || ''
            });
            
            // 根据 tlIndex 决定上传类型
            if(this.tlIndex == 11){
                uploadPromises.push(this.handleWfssUploadSingle(updatedFile));
            } else if(this.tlIndex == 10){
                uploadPromises.push(this.handleZtzgUploadSingle(updatedFile));
            } else {
                uploadPromises.push(this.handleXcjcUploadSingle(updatedFile));
            }
        }
        
        // 等待所有上传完成
        Promise.all(uploadPromises).then(() => {
            this.dialogVisible = false;
            // 清空相关数据
            this.currentFileList = [];
            this.fileNamesList = [];
            this.fileNames = '';
            this.fileNameSc = '';
        }).catch(error => {
            console.error('上传过程中出现错误:', error);
        });
    } else {
        // 单文件上传逻辑
        if (!this.fileNameSc) {
            this.$message.error('请输入文件名');
            return;
        }
        
        const file = this.currentFileList && this.currentFileList.length > 0 ? this.currentFileList[0] : this.currentFile;
        let newFileName = this.fileNameSc; // 用户输入的文件名
        
        // 如果用户输入的文件名不包含扩展名，则添加原文件的扩展名
        if (file.name) {
            const lastDotIndex = file.name.lastIndexOf('.');
            if (lastDotIndex > 0) {
                const extension = file.name.substring(lastDotIndex);
                // 检查用户输入的文件名是否已经包含扩展名
                if (!newFileName.endsWith(extension)) {
                    newFileName = newFileName + extension;
                }
            }
        }
        
        const updatedFile = new File([file], newFileName, {
            type: file.type || ''
        });
        
        // 执行上传
        if(this.tlIndex == 11){
            this.handleWfssUpload({
                file: updatedFile,
                fileList: [updatedFile]
            });
        } else if(this.tlIndex == 10){
            this.handleZtzgUpload({
                file: updatedFile,
                fileList: [updatedFile]
            });
        } else {
            this.handleXcjcUpload({
                file: updatedFile,
                fileList: [updatedFile]
            });
        }
        
        this.dialogVisible = false;
        // 清空相关数据
        this.currentFileList = [];
        this.fileNamesList = [];
        this.fileNames = '';
        this.fileNameSc = '';
    }
},
    // 单文件上传的简化版本
    handleWfssUploadSingle(file) {
        return new Promise((resolve, reject) => {
            this.customUpload({ file: file, fileList: [file] }, 'wfsszj')
                .then(resolve)
                .catch(reject);
        });
    },
    
    handleZtzgUploadSingle(file) {
        return new Promise((resolve, reject) => {
            this.customUpload({ file: file, fileList: [file] }, 'ztzgzj')
                .then(resolve)
                .catch(reject);
        });
    },
    
    handleXcjcUploadSingle(file) {
        return new Promise((resolve, reject) => {
            this.customUpload({ file: file, fileList: [file] }, 'xcjczj')
                .then(resolve)
                .catch(reject);
        });
    },
    
    // 修改原有的 customUpload 方法返回 Promise
    customUpload({ file, fileList = [] }, field) {
        return new Promise((resolve, reject) => {
            console.log(file, fileList, field, 2000);
            this.dialogVisible = false;
            const isValid = this.beforeUpload(file);
            if (!isValid) {
                reject(new Error('文件验证失败'));
                return;
            }

            const formData = new FormData();
            // 如果有多个文件，上传所有文件
            if (fileList.length > 0) {
                fileList.forEach(f => {
                    formData.append("files", f.raw || f);
                    formData.append("fileName", file.name);
                });
            } else {
                // 否则上传单个文件
                formData.append("files", file.raw || file);
                formData.append("fileName", file.name);
            }
            formData.append("lsh", this.xcblLsh);
            formData.append("mid", this.form1.mid);
            formData.append("fileType", field === 'ztzgzj' ? 1 : (field === 'wfsszj'? 2 : 3));
            
            this.$axios.post(this.baseUrl+`/xx/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                this.currentFileList = []; // 清空文件列表
                this.fileNames = ''; // 清空文件名
                this.tlIndex = 0;
                this.fileNamesList = []; // 清空文件名列表
                this.fileNamesSc = ''; // 清空单个文件名

                if(response.data.code == 0){
                    console.log('上传成功:', response.data);
                    this.xcblLsh = response.data.filenewname.lsh
                    this.getUpload()
                    resolve(response.data);
                }else{
                    this.$message.error(response.data.msg);
                    this.tlIndex = 0
                    reject(new Error(response.data.msg));
                }
            })
            .catch(error => {
                this.currentFileList = []; // 清空文件列表
                this.fileNames = ''; // 清空文件名
                this.tlIndex = 0;
                this.fileNamesList = []; // 清空文件名列表
                this.fileNamesSc = ''; // 清空单个文件名
                console.error('上传失败:', error);
                this.$message.error('上传失败!');
                reject(error);
            })
            .finally(() => {
                this.currentFileList = []; // 清空文件列表
                this.fileNames = ''; // 清空文件名
                this.tlIndex = 0;
                this.fileNamesList = []; // 清空文件名列表
                this.fileNamesSc = ''; // 清空单个文件名
            });
        });
    },
        
        
        getUpload(){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectUpload`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.xcblLsh,
                }
            })
            .then(response => {
                console.log(response.data);
                if(response.data.code==0){
                    this.ztzgzjTags = response.data.data.selectUploadResOne || []
                    this.wfsszjTags = response.data.data.selectUploadResTwo || []

                    this.xcjczjTags = (response.data.data.selectUploadResThree || []).map(item => ({
                        ...item,
                        isEditing: false
                        }));

                }
                this.tlIndex = 0
            })
            .catch(error => {
                this.tlIndex = 0
                console.error('There was an error!', error);
            });
        },
        deleUpload(id){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/delZhengJu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id
                }
            })
            .then(response => {
                console.log(response.data);
                if(response.data.code==0){
                    this.getUpload()
                }
                this.tlIndex = 0
            })
            .catch(error => {
                this.tlIndex = 0
                console.error('There was an error!', error);
            });
        },
        getHebing(data) {
            let totalFakuan = 0;
            let totalMoshou = 0;

            // 初始化所有字段为默认值
            this.$set(this.form2, 'jinggao', '0');
            this.$set(this.form2, 'tongbao', '0');
            this.$set(this.form2, 'fakuan', '0');
            this.$set(this.form2, 'fakuanJine', '');
            this.$set(this.form2, 'moshouweifasuode', '0');
            this.$set(this.form2, 'moshouweifasuodeJine', '');
            this.$set(this.form2, 'diaoxiao', '0');
            this.$set(this.form2, 'diaoxiaoName', '');
            this.$set(this.form2, 'zeling', '0');
            this.$set(this.form2, 'zelingName', '');
            this.$set(this.form2, 'moshouwupin', '0');
            this.$set(this.form2, 'moshouwupinName', '');
            this.$set(this.form2, 'jiangdizizhidengji', '0');

            data.forEach(item => {
                if (item.nycf) {
                    const parts = item.nycf.split(/,|，|、/); // 按逗号、中文逗号、顿号分割
                    parts.forEach(part => {
                        const cleanPart = part.trim();

                        // 警告
                        if (cleanPart.includes('警告')) {
                            this.$set(this.form2, 'jinggao', '1');
                        }
                        // 通报批评
                        if (cleanPart.includes('通报批评')) {
                            this.$set(this.form2, 'tongbao', '1');
                        }
                        // 罚款
                        if (cleanPart.includes('罚款')) {
                            const amountStr = cleanPart.split('罚款')[1].replace(/[^\d.]/g, '');
                            const amount = parseFloat(amountStr);
                            if (!isNaN(amount)) {
                                totalFakuan += amount;
                            }
                        }
                        // 没收违法所得
                        if (cleanPart.includes('没收违法所得')) {
                            const amountStr = cleanPart.split('没收违法所得')[1].replace(/[^\d.]/g, '');
                            const amount = parseFloat(amountStr);
                            if (!isNaN(amount)) {
                                totalMoshou += amount;
                            }
                        }
                        // 吊销
                        if (cleanPart.includes('吊销')) {
                            this.$set(this.form2, 'diaoxiao', '1');
                            this.$set(this.form2, 'diaoxiaoName', cleanPart.split('吊销')[1].trim());
                        }
                        // 责令
                        if (cleanPart.includes('责令')) {
                            this.$set(this.form2, 'zeling', '1');
                            this.$set(this.form2, 'zelingName', cleanPart.split('责令')[1].trim());
                        }
                        // 没收物品
                        if (cleanPart.includes('没收（物品）')) {
                            this.$set(this.form2, 'moshouwupin', '1');
                            this.$set(this.form2, 'moshouwupinName', cleanPart.split('没收（物品）')[1].trim() || '物品');
                        }
                        // 降低资格等级
                        if (cleanPart.includes('降低资格等级')) {
                            this.$set(this.form2, 'jiangdizizhidengji', '1');
                        }
                    });
                }
            });

            // 设置罚款金额（保留两位小数）
            if (totalFakuan > 0) {
                this.$set(this.form2, 'fakuan', '1');
                this.$set(this.form2, 'fakuanJine', totalFakuan.toFixed(2));
            }

            // 设置没收非法所得金额（保留两位小数）
            if (totalMoshou > 0) {
                this.$set(this.form2, 'moshouweifasuode', '1');
                this.$set(this.form2, 'moshouweifasuodeJine', totalMoshou.toFixed(2));
            }
        },
        openFile(fileUrl) {
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            } else {
                this.$message.warning('无法打开文件，请联系管理员');
            }
        },
        // 去除文件名后缀的方法
        removeFileExtension(filename) {
            if (!filename) return '';
            // 查找最后一个点的位置
            const lastDotIndex = filename.lastIndexOf('.');
            // 如果找到了点并且不是在开头或结尾
            if (lastDotIndex > 0 && lastDotIndex < filename.length - 1) {
                return filename.substring(0, lastDotIndex);
            }
            // 如果没有找到后缀，返回原文件名
            return filename;
        },
        handleScxcjc(){},
        deleteXcjc(row){}
    }
}
</script>


<style scoped>



.box-cont >>> .search .el-input__inner{ border-radius: 20px;}
.box-cont >>> .el-input.is-disabled .el-input__inner { color: #333;}
.box-cont ul li{padding: 0px 10px 0 15px; margin-top: 10px; width: calc(100% - 27px);height: 46px; line-height: 46px;font-size: 14px;color: #333333; background: #FFFFFF;border-radius: 2px;border: 1px solid #DEDEDE;cursor: pointer;}
.box-cont ul li.active{ color: #0C80E8;}
.box-cont ul li span{ float: left;width: calc(100% - 50px);overflow: hidden; white-space: nowrap;text-overflow: ellipsis;}
.box-cont ul li i{color: #0C80E8; float: right; line-height: 46px; font-size: 18px;}
.liebiao >>> .el-button{border:none;padding: 0;    line-height: 54px;
    font-size: 16px;background: none;width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;text-align: left;}
.content >>>    .el-loading-spinner{
  font-size: 100px;
}
.loading{ width: 100vw; height: 100vh; background: rgba(255,255,255,0.5); position: fixed; top:0;left: 0;text-align: center;z-index: 3000;}
.loading i{    font-size: 100px;color: #1890ff;opacity: 1; margin-top: 30vh;}
.loading p{   font-size: 20px; color: #333; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}



.ajtl{ width: 100%;}
.ajtl-item{ width: calc(100% - 20px); padding:0 20px; display: flex;} 
.tl-border{ border:2px #eee dashed;border-radius: 10px; padding:20px 20px;}
.ajtl-item .el-card{ width:calc((100% - 248px) / 3); margin-bottom:0;}
.ajtl-item2 .el-card{ width:calc((100% - 248px) / 3 * 2 + 124px);}
.ajtl-item >>> .activeC.el-card{border: solid 1px #0c80e8;}
.ajtl-item >>> .activeC.el-card .el-card__header { background: #0c80e8;border-bottom: solid 1px #0c80e8; color:#fff;}
.ajtl-item >>> .activeC.el-card .el-card__header .el-button--text{color:#fff;}
.jiantou {
    width: 104px;
    margin:0 10px;
    display: flex;
    flex-direction: column;
    vertical-align: middle;
    justify-content: center;  /* 垂直方向居中 */
    align-items: center;      /* 水平方向居中 */
    min-height: 180px;        /* 容器需要高度 */
    margin-top: -60px;
}
.jiantou a{
    display: inline-block;
    padding-left: 16px;
    width: 54px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color:#fff;
    cursor: pointer;
}
.jiantou p{
    width: 104px;
    height:12px;
    background:url(../../../assets/images/jtY.png) no-repeat center right;
    background-size: auto 12px;
}
.jtS p{background:url(../../../assets/images/jtS.png) no-repeat center right;}
.ajtl-jt{ width:calc((100% - 248px) / 3);}
.jiantou2 {
    height: 100px;
    margin:0 auto;
    display: flex;
    flex-direction: column;
    vertical-align: middle;
    align-items: center;
    min-height: 100px;
    position:relative;
}
.jiantou2 p{
    width: 13px;
    height:85px;
    background:url(../../../assets/images/jtX.png) no-repeat center right;
    background-size:13px auto ;
}
.jtSx p{ background:url(../../../assets/images/jtXS.png) no-repeat center right;}
.jiantou2 a{position:absolute;top:35px;display: none;}
.lastJt{ width:176px;height:125px;margin-top: -125px;position: relative;}
.lastJt a{margin-top:80px; position:absolute;top:80px;}
.lastJt p{ width:176px;height:125px; background:url(../../../assets/images/jtW.png) no-repeat bottom right;}
.activeJ a.activeA,.tlAnniu{width:70px;height:26px; display:block; background: url(../../../assets/images/tlBtn.png) no-repeat center;
    background-size: 100% 100%; color:#0C80E8;}
.jiantou.activeJ p{ background:url(../../../assets/images/jtY2.png) no-repeat center right;}
.jtS.activeJ p{background:url(../../../assets/images/jtS2.png) no-repeat center right;}
.jiantou2.activeJ p{ background:url(../../../assets/images/jtX2.png) no-repeat center right;}
.jtSx .activeJ p{ background:url(../../../assets/images/jtXS2.png) no-repeat center right;}
.lastJt.activeJ p{ background:url(../../../assets/images/jtW2.png) no-repeat center right;}
.lastJt.activeJ a{ position: absolute; top: 40px;}
.ajtl >>> .el-card .el-card__body{padding:10px !important;}
.tl-content{  width: 100%;min-height: 130px; position:relative;}
.tl-tabs{width:calc(100% + 10px); margin-left:-5px;display: flex; margin-bottom:10px;overflow-x: auto;}
.tl-tabs a{min-width: 140px;flex: 1;margin:0 5px; height: 32px;background: #F0F0F0; color: #333; text-align: center; line-height: 32px; font-size: 14px; cursor: pointer;}
.tl-tabs a.active{background:#CAE2F9;color: #0C80E8;}
.tl-main{  width: 100%;}
.tl-content >>> .el-form-item{ margin-bottom: 0px;}
.fuzhi{ position:absolute; bottom:10px; right:36px; cursor: pointer; width:8px;height:8px;background:#fff; border:solid 1px #999;}
.fuzhi i{ width:8px;height:8px;background:#fff; border:solid 1px #999; display:block; margin: 2px -3px 0;}
.fangda{ position:absolute; bottom:7px; right:18px; cursor: pointer; width:14px;height:14px;}
.fangda img{display: block;}


.tlContainer {
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
}
.header {
    padding: 20px;
    background: #007bff;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
.section {
    padding: 20px;
    border-bottom: 1px solid #eee;
}
.section h2 {
    font-size: 16px;
    margin-bottom: 10px;
    color: #333;
}
.input-group {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    width: 100%;
}
.section >>> .el-form-item{margin-bottom:15px;}
.section >>> .jieguo .el-loading-spinner{top:5vh}
.ajtl-item >>> .el-loading-spinner,.tl-border >>> .el-loading-spinner{top:0}
::v-deep .ajtl .el-tabs__item:last-child .el-icon-close {
  display: none;
}
/*::v-deep .tag-container .el-tag {display:block !important;width: max-content;}*/

::v-deep .el-input.is-disabled .el-input__inner {
    color: #000 !important;
}
</style>
